import { useCallback, useEffect, useState } from 'react';
import { getPendingApprovalIncidenceRequestsSummary } from 'api/incidence-request.api';

export const incidencePendingSummaryRefreshEvent =
  'incidence-pending-summary:refresh';

export const dispatchIncidencePendingSummaryRefresh = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new Event(incidencePendingSummaryRefreshEvent));
};

export const useIncidencePendingSummary = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const [hasPending, setHasPending] = useState(false);

  const loadPendingSummary = useCallback(async () => {
    if (!enabled) {
      setHasPending(false);
      return;
    }

    try {
      const response = await getPendingApprovalIncidenceRequestsSummary();
      setHasPending(response.data.data.hasPending);
    } catch {
      setHasPending(false);
    }
  }, [enabled]);

  useEffect(() => {
    void loadPendingSummary();
  }, [loadPendingSummary]);

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') {
      return;
    }

    const refreshPendingSummary = () => {
      void loadPendingSummary();
    };

    window.addEventListener(
      incidencePendingSummaryRefreshEvent,
      refreshPendingSummary
    );

    return () => {
      window.removeEventListener(
        incidencePendingSummaryRefreshEvent,
        refreshPendingSummary
      );
    };
  }, [enabled, loadPendingSummary]);

  return {
    hasPending,
    refreshPendingSummary: loadPendingSummary,
  };
};
